import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { withTranslation } from 'react-i18next';
import MessageSenderSimple from '../components/general/MessageSenderSimple';
import CommentsList from '../components/lists/comments/CommentsList';

const CommentsListAndCreate = ({
  t,
  currentUser,
  parentGuid,
  comments,
  onPublishComment,
  placeholder,
  onDelete,
  onEdit,
  disabled,
  maxComments,
  onMarkAsRead,
  showFeedbackOption,
  onFeedback,
  feedbackQuestionType,
}) => {
  const [showAll, setShowAll] = useState(!maxComments);

  return (
    <div className="comments-list-and-create">
      {comments && comments.length > 0 && (
        <div className="comments-list-and-create__list">
          <CommentsList
            parentGuid={parentGuid}
            currentUser={currentUser}
            comments={showAll ? comments : comments.slice(0, 2)}
            onEdit={onEdit}
            onDelete={onDelete}
            maxComments={maxComments}
            onMarkAsRead={onMarkAsRead}
            disabled={disabled}
          />
        </div>
      )}
      {comments && maxComments && comments.length > 2 && !showAll && (
        <div className="comments-list-and-create__view-all" onClick={() => setShowAll(true)}>
          {t('common:View all comments')} {`(${comments.length - 2})`}
        </div>
      )}
      {!disabled && (
        <div className="comments-list-and-create__sender">
          <MessageSenderSimple
            disabled={disabled}
            currentUser={currentUser}
            onPublishComment={onPublishComment}
            parentGuid={parentGuid}
            placeholder={placeholder}
            showFeedbackOption={showFeedbackOption}
            onFeedback={onFeedback}
            feedbackQuestionType={feedbackQuestionType}
          />
        </div>
      )}
    </div>
  );
};

CommentsListAndCreate.propTypes = {
  comments: PropTypes.array,
  disabled: PropTypes.bool,
  onMarkAsRead: PropTypes.func,
  showFeedbackOption: PropTypes.bool,
  onFeedback: PropTypes.func,
  feedbackQuestionType: PropTypes.string,
  currentUser: PropTypes.object,
  parentGuid: PropTypes.string,
  onPublishComment: PropTypes.func,
  placeholder: PropTypes.string,
  onDelete: PropTypes.func,
  onEdit: PropTypes.func,
  maxComments: PropTypes.number,
  t: PropTypes.func,
};

CommentsListAndCreate.defaultProps = {
  comments: [],
  disabled: false,
  maxComments: false,
};

export default withTranslation(['common', 'placeholder', 'my-courses'])(CommentsListAndCreate);
